module.exports = __webpack_public_path__ + "img/gigwidog2.2dabc711.jpg";